export default __webpack_public_path__ + "static/media/login.a3a55d51.png";